export default {
  'PerformerPage.Title': { en: 'Musicians and Acts', fr: 'Musiciens et actes' },
};
